"use strict";

exports.__esModule = true;
exports.ElementActionControlGroup = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _reactIntl = require("react-intl");
var _UserActions = require("../../../UserActions");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Controls for configuring onClick behaviour.
 */
var ElementActionControlGroup = exports.ElementActionControlGroup = /*#__PURE__*/function (_Component) {
  function ElementActionControlGroup() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(ElementActionControlGroup, _Component);
  var _proto = ElementActionControlGroup.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      elementEditor = _this$props.elementEditor,
      controlPaths = _this$props.controlPaths;
    var onClickAction = controlPaths.onClickAction;
    if (!onClickAction) {
      console.warn("No onClickAction set so not showing any action form configuration options");
      return null;
    }
    var userActions = elementEditor.getAvailableUserActionsAt(onClickAction);
    if (userActions.length === 0) {
      console.warn("No userActions so not showing any action form configuration options");
      return null;
    }
    var config = elementEditor.getProp(onClickAction, "onClickAction");
    var selected = config && config.name ? [config.name] : [];
    var selector = /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "ElementActionControlGroup.selector.label",
        defaultMessage: "On Click Action"
      })
    }, /*#__PURE__*/_react["default"].createElement(_UserActions.UserActionSelector, {
      selected: selected,
      items: userActions,
      toggle: true,
      onSelect: function onSelect(items) {
        return items.length === 0 ? elementEditor.deleteProp(onClickAction, "onClickAction") : elementEditor.setProp(onClickAction, "onClickAction", {
          name: items[0].name
        });
      }
    }));
    if (selected.length === 0) {
      return selector;
    }
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, selector, /*#__PURE__*/_react["default"].createElement(_UserActions.UserActionFields, {
      userActions: userActions,
      config: config,
      onChange: function onChange(newConfig) {
        return elementEditor.setProp(onClickAction, "onClickAction", newConfig);
      }
    }));
  };
  return ElementActionControlGroup;
}(_react.Component);